module.exports = __webpack_public_path__ + "img/carli-lloyd.d2c2a660.png";